import { Injectable } from '@angular/core';
import { OperadoraState } from '../states/operadora.state';
import { IProduto } from '../types/IProduto';

@Injectable({ providedIn: 'root' })
export class OperadoraFacade {
  
  constructor(
    private operadoraState: OperadoraState,
  ) { }

  selectOperadora(operadora: IProduto) {
    this.operadoraState.selectOperadora(operadora);
  }

  setOriginalState(operadora: IProduto) {
    this.operadoraState.setOriginalState(operadora);
  }

  getOperadoraSelecionada() {
    return this.operadoraState.getOperadoraSelecionada();
  }

  observeOperadoraSelecionada() {
    return this.operadoraState.observeOperadoraSelecionada();
  }

  filterByUf(ufDescription: string) {
    this.operadoraState.filterByUf(ufDescription);
  }

  clearFilter() {
    this.operadoraState.resetToOriginalState();
  }
}